<template>
    <div data-test-view="meetings">
        <l-module-access
            :module="'meetings'"
            :module-access="team.moduleAccess"
            :title="$t(`adminSettings.meetingsHeadlineTitle`)"
        ></l-module-access>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import LModuleAccess from "@/components/LModuleAccess";

import icon from "@/img/icons/meetings.png";

export default {
    components: {
        LModuleAccess,
    },
    data() {
        return {
            icon,
            team: {},
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            getTeamInfo: "teams/current/info",
            getMeetingSections: "meetings/sections/list",
        }),
    },
    created() {
        // Cloning the information from the store so we can modify it before updating the store,
        // when the user clicks on the update button.
        //
        this.team = this.getTeamInfo();
        this.sections = this.getMeetingSections({ scope: "admin" });
    },
};
</script>

<style scoped></style>
